import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {first, map} from 'rxjs/operators';
import {ProductService} from '../../../services/product.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {CategoryService} from '../../../services/category.service';
import {ResourceService} from '../../../services/resource.service';
import {MerchantService} from '../../../services/merchant.service';
import {BrandService} from "../../../services/brand.service";
import {GroupBrandService} from "../../../services/group-brand.service";
import {GroupTypeProductService} from "../../../services/group-type-product.service";
import {GroupSubTypeProductService} from "../../../services/group-sub-type-product.service";

declare var swal: any;

@Component({
    selector: 'app-product-add-edit',
    templateUrl: './product-add-edit.component.html',
    styleUrls: ['./product-add-edit.component.scss']
})
export class ProductAddEditComponent implements OnInit {

    Editor = ClassicEditor;
    configEditor = {
        language: 'es'
    };

    optionsSelect2 = {
        width: '100%',
        language: 'es',
        delay: 250,
    };

    categories = [];
    merchants = [];

    submitted = false;
    loading = false;
    id: number;
    countRequests = 0;
    product = {
        id: null,
        name: null,
        merchant: null,
        merchant_id: null,
        category_id: null,
        brand_id: null,
        type_product_id: null,
        sub_type_product_id: null,
        description: null,
        file_features: null,
        product_status: null,
        status: '1',
        variants: [],
        combinations: [],
        title_seo: null,
        description_seo: null,
        keywords: null,
        variants_combinations_stored: [],
    };

    brands = [];
    type_products = [];
    sub_type_products = [];

    FileNameLoaded = 'Arrastra o busca un archivo pdf';

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private productService: ProductService,
        private categoryService: CategoryService,
        private merchantService: MerchantService,
        private resourceService: ResourceService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private brandService: BrandService,
        private groupBrandService: GroupBrandService,
        private groupTypeProductService: GroupTypeProductService,
        private groupSubTypeProductService: GroupSubTypeProductService,
    ) {
    }

    ngOnInit() {
        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.spinner.show();
            this.loadCategories();

            this.productService.getById(this.id).pipe(first()).subscribe(response => {
                this.reloadDataSelect(response.data.category_id, response.data.brand_id, response.data.type_product_id);
            },error => {
                this.toastrService.error(error);
            });

            this.productService.getById(this.id).pipe(first()).subscribe(response => {
                if (this.countRequests == 1) {
                    this.spinner.hide();
                }
                this.countRequests++;
                this.product.id = response.data.id;
                this.product.name = response.data.name;
                this.product.merchant = response.data.merchant;
                this.product.category_id = response.data.category_id;
                this.product.brand_id = response.data.brand_id;
                this.product.type_product_id = response.data.type_product_id;
                this.product.sub_type_product_id = response.data.sub_type_product_id;
                this.product.description = response.data.description;
                this.product.product_status = response.data.product_status;
                this.product.status = response.data.status;
                this.product.title_seo = response.data.title_seo;
                this.product.description_seo = response.data.description_seo;
                this.product.keywords = response.data.keywords;
                this.product.variants_combinations_stored = response.data.variants_combinations_stored;
            }, error => {
                this.spinner.hide();
                this.router.navigate(['']);
            });
        } else {
            this.spinner.show();
            this.merchantService.getAll(1).pipe(first()).subscribe(response => {
                this.merchants = response.data;
                if (this.countRequests == 1) {
                    this.spinner.hide();
                }
                this.countRequests++;
            }, error1 => {
                this.toastrService.error(error1);
            });
            this.loadCategories();
        }
    }

    loadCategories() {
        this.categoryService.getAll(1).pipe(first()).subscribe(response => {
            if (this.countRequests == 1) {
                this.spinner.hide();
            }
            this.countRequests++;
            this.categories = response.data;
        }, error1 => {
            this.spinner.hide();
            this.toastrService.error(error1, 'Error');
        });
    }

    reloadDataSelect(category_id: number, brand_id: number, type_product: number) {
        this.getBrands(category_id);
        this.getTypeProducts(brand_id);
        this.getSubTypeProducts(type_product);
    }

    getBrands(item: number) {
        let info = {};
        this.brands = [];
        this.type_products = [];
        this.sub_type_products = [];
        this.groupBrandService.getBrands(item).subscribe(response => {
            response.data.forEach(value => {
                info = {
                    id: value.id,
                    text: value.name,
                };
                this.brands.push(info);
            })
        }, error => {
            this.spinner.hide();
            this.toastrService.error(error, 'Error');
        });
    }

    onSelectCategory(item) {
        this.product.type_product_id = null;
        this.product.brand_id = null;
        this.product.sub_type_product_id = null;

        if (item != null) {
            this.getBrands(item);
        }
    }

    getTypeProducts(item: number) {
        let info = {};
        this.type_products = [];
        this.sub_type_products = [];
        this.groupTypeProductService.getTypeProducts(item).subscribe(response => {
            response.data.forEach(value => {
                info = {
                    id: value.id,
                    text: value.name,
                };
                this.type_products.push(info);
            })
        }, error => {
            this.spinner.hide();
            this.toastrService.error(error, 'Error');
        });
    }

    onSelectBrand(item) {
        this.product.brand_id = null;
        this.product.sub_type_product_id = null;
        if (item != null) {
            this.getTypeProducts(item);
        }
    }

    getSubTypeProducts(item: number) {
        let info = {};
        this.sub_type_products = [];
        this.groupSubTypeProductService.getSubTypeProducts(item).subscribe(response => {
            response.data.forEach(value => {
                info = {
                    id: value.id,
                    text: value.name,
                };
                this.sub_type_products.push(info);
            });
        }, error => {
            this.spinner.hide();
            this.toastrService.error(error, 'Error');
        });
    }

    onSelectTypeProduct(item) {
        this.product.sub_type_product_id = null;
        if (item != null) {
            this.getSubTypeProducts(item);
        }
    }

    sendForm(): void {
        console.log(this.product);
        this.submitted = true;
        if (!this.product.id) {
            if (!this.validateForm()) {
                swal.fire({
                    title: 'Complete todo los campos',
                    type: 'info'
                });
                return;
            }
            this.loading = true;
            this.productService.store(this.product).subscribe(response => {
                this.loading = false;
                this.toastrService.success(response.message, 'Éxito!');
                this.router.navigate(['/products']);
            }, error1 => {
                this.loading = false;
                this.toastrService.error(error1);
            });
        } else {
            if (!this.validateForm()) {
                swal.fire({
                    title: 'Complete todo los campos',
                    type: 'info'
                });
                return;
            }
            this.loading = true;
            this.productService.update(this.product).subscribe(response => {
                this.loading = false;
                this.toastrService.success(response.message, 'Éxito!');
                this.router.navigate(['/products']);
            }, error1 => {
                this.loading = false;
                this.toastrService.error(error1);
            });
        }
    }

    validateForm(): boolean {
        if (!this.product.name || !this.product.category_id || (!this.id && !this.product.merchant_id) || !this.product.description || !this.product.title_seo ||
            !this.product.description_seo || !this.product.keywords) {
            return false;
        }

        let valid = true;
        if (this.id) {
            this.product.variants_combinations_stored.forEach(combination => {
                if (!combination.price || !combination.old_price) {
                    valid = false;
                }
            });
        } else {
            if (this.product.combinations.length > 0) {
                this.product.combinations.forEach(combination => {
                    if (!combination.price || !combination.old_price || !combination.stock) {
                        valid = false;
                    }
                });
            } else {
                valid = false;
            }
        }
        return valid;
    }

    addVariant(): void {
        this.product.variants.push({
            name: '',
            details: []
        });
    }

    deleteVariant(index: number): void {
        this.product.variants.splice(index, 1);
        this.calculateCombinations();
    }

    calculateCombinations(): void {
        if (this.product.variants.length > 0) {
            let preCombinations = [];
            this.product.variants.forEach((variant, keyVariant) => {
                let arrPAso = [];
                variant.details.forEach(function (detail, keyDetail) {
                    arrPAso.push({
                        key_attribute: keyVariant,
                        key_details_attribute: keyDetail,
                        name_details_attribute: detail
                    });
                });
                preCombinations.push(arrPAso);
            });
            this.product.combinations = this.combination(preCombinations);
        } else {
            this.product.combinations = [];
        }
    }

    combination(arr): Array<any> {
        let arr1 = arr[0];
        let allCombinations = [];

        if (arr.length == 1) {
            arr1.forEach(function (value) {
                allCombinations.push({
                    name_variant_combination: value.name_details_attribute,
                    price: '',
                    old_price: '',
                    stock: '',
                    photo: null,
                    photo_url: null,
                    selected: false,
                    combinations_positions: [value]
                });
            });
        } else if (arr.length == 2) {
            let arr2 = arr[1];
            arr1.forEach(function (valueArr1) {
                arr2.forEach(function (valueArr2) {
                    allCombinations.push({
                        name_variant_combination: (valueArr1.name_details_attribute + ' - ' + valueArr2.name_details_attribute),
                        price: '',
                        old_price: '',
                        stock: '',
                        photo: null,
                        photo_url: null,
                        selected: false,
                        combinations_positions: [valueArr1, valueArr2]
                    });
                })
            });
        } else {
            let arr2 = arr[1];
            let arr3 = arr[2];
            for (let i = 0; i < arr1.length; i++) {
                for (let y = 0; y < arr2.length; y++) {
                    for (let x = 0; x < arr3.length; x++) {
                        allCombinations.push({
                            name_variant_combination: (arr1[i].name_details_attribute + ' - ' + arr2[y].name_details_attribute + ' - ' + arr3[x].name_details_attribute),
                            price: '',
                            old_price: '',
                            stock: '',
                            photo: null,
                            photo_url: null,
                            selected: false,
                            combinations_positions: [arr1[i], arr2[y], arr3[x]]
                        });
                    }
                }
            }
        }
        return allCombinations;
    }

    onSelectFile(fileInput, combination) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'products');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                combination.selected = true;
                combination.photo = response.file;
                combination.photo_url = response.file_url;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }

    onSelectFileArchive(fileInput) {
        let archiveFile = <File>fileInput.target.files[0];
        if (archiveFile) {
            const formData = new FormData();
            formData.append('file', archiveFile);
            formData.append('path', 'features');
            this.spinner.show();
            this.resourceService.uploadArchive(formData).pipe(first()).subscribe(response => {
                this.product.file_features = response.file;
                this.FileNameLoaded = archiveFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }
}
